import { Component, Inject, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

export interface LoadingDialogInput
{
    title: string;
}

@Component({
    selector: 'app-loading-dialog',
    templateUrl: './loading-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MatIconModule,
        MatDialogModule,
        MatProgressSpinnerModule,
    ],
})
export class LoadingDialogComponent implements OnInit
{

    constructor(
            private _dialogRef: MatDialogRef<LoadingDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: LoadingDialogInput,
    ) {
    }

    ngOnInit() {
    }

}
